import { render, staticRenderFns } from "./StockLocation.vue?vue&type=template&id=438a02c4&lang=pug&"
import script from "./StockLocation.vue?vue&type=script&lang=ts&"
export * from "./StockLocation.vue?vue&type=script&lang=ts&"
import style0 from "./StockLocation.vue?vue&type=style&index=0&id=438a02c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports